import React, {useState} from 'react';
import Header from "../../components/header/header.jsx";
import TypePanel from "../../components/type-panel/type-panel.jsx";
import MaterialPanel from "../../components/material-panel/material-panel.jsx";
import TeethChart from "../../components/tooth-chart/teeth.jsx";
import AdditionalInfo from "../../components/aditional-info/additional-info.jsx";
import {
    getToothPosition,
    getPositionsWithoutBridges,
    topBorders,
    bottomBorders,
    getBridgedTeeth
} from "../../components/common/teeth";


const Planning = (props)=>{

    const{
        teethState,
        setTeethState,
        bridges,
        setBridges,
        type,
        setType,
        appState,
        setAppState,
        activeTeeth,
        setActiveTeeth,
        currency,
        setCurrency,
        setCurScreen,
        fieldsState,
        setFields
    } = props;


    const [bridgeState, setBridgeState ] = useState("init");
    const [bridgeProgress, setBridgeProgress ] = useState(null);
    const [isBridgeEditing, setIsBridgeEditing ] = useState(false);
    const [overDentureType, setOverDentureType] = useState(null);
    const [popState, setPopState ] = useState(false);


    const canClear = ()=>{
        return(
            bridgeState !== "init" ||
            bridgeProgress ||
            overDentureType ||
            popState ||
            getMaterialState() === "show-materials"
        )
    }

    const clear1 = ()=>{
        if(!canClear()) return;
        setAppState("open");
        setType(null);
        setBridgeProgress(null);
        setIsBridgeEditing(false);
        setOverDentureType(null);
        setPopState(false);

        //TODO implant/abutment without material
    }

    const clear = ()=>{
        setActiveTeeth([]);
        setAppState("open");
        setType(null);
        setBridgeProgress(null);
        setBridgeState("init");
        setPopState(false);
        setOverDentureType(null);
        setBridges(prevState=>{
            const newState = [...prevState];
            newState.map((bridge,index)=>{
                if(bridge.bridgeProcess) newState.splice(index,1);
            })
            return newState;
        })
        setTeethState(prevState=>{
            const newState = [...prevState];
            newState.forEach(tooth=>tooth.faded = false );
            newState.filter(tooth=>tooth.state !== "healthy" && (!tooth.inSetBridge && !tooth.isTelescopicCrown))
                .forEach(tooth=>tooth.state = "healthy");
            return newState;
        });
    }


    const setBridge = (material,bridgeType)=>{
        setTeethState(prevState => {
            const newState = [...prevState];
           // const teeth = (type === 1)? bridgeState.teeth[0] : activeTeeth;
            let teeth = [];
            if(type === 1){
                const bridgedTeeth = overDentureType === "partial"? bridges.find(bridge=>bridge.bridgeProcess).teeth : bridgeState.teeth[0];
                teeth = getBridgedTeeth(bridgedTeeth,true);
            }else teeth = activeTeeth;
            for(const tooth of teeth){
                const toothState = newState.find(item=> item.id === tooth);
                toothState.material = material;
                if(toothState.state === "implant"){
                    //toothState.material = material;
                    toothState.inSetBridge = true;
                    toothState.isTelescopicCrown = false;
                }
            }
            return newState;
        });
        if(type === 1){
            setBridges(prevState=>{
                const newState = [...prevState];
                newState.push({...bridgeState, material,bridgeType});
                return newState;
            })
        }else if(type === 2){

            if(overDentureType === "whole"){
                const {position} = bridgeProgress;
                let bridgesToAdd = [];
                if(position === "both"){
                    bridgesToAdd = [topBorders, bottomBorders].map(teeth=>{
                        return {material,bridgeType,teeth:[teeth],overDentureType:"whole"}
                    })
                }else{
                    const teeth = position === "top"? topBorders: bottomBorders
                    bridgesToAdd = [{material,bridgeType,teeth:[teeth]}]
                }

                setBridges(prevState=>{
                    return [...prevState, ...bridgesToAdd];
                })
            }else{
                setBridges(prevState=>{
                    const newBridges = [...prevState];
                    const partialBridge = newBridges.find(bridge=>bridge.bridgeProcess)
                    partialBridge.bridgeProcess = false;
                    partialBridge.overDentureType = "partial";
                    partialBridge.material = material;
                    return newBridges;
                })
            }
            setBridgeProgress(null);
            setOverDentureType(null);
            setActiveTeeth([]);
        }
        setTeethState(prevState=>{
            const newState = [...prevState];
            newState.forEach((item)=>{
                item.faded = false;
            });
            return newState;
        });
        setBridgeProgress(null);
        setBridgeState("other");
        setIsBridgeEditing(false);
    }

    const materialChanged  = (material)=>{

        switch (type) {

            case 0: // Telescopic Crown
                setTeethState(prevState => {
                    const newState = [...prevState];
                    for(const activeTooth of activeTeeth){
                        newState.find(item=> item.id === activeTooth).material = material;
                    }
                    return newState;
                });
                break;
            case 1: // Telescopic bridge
                setBridge(material,"telescopic");
                break;
            case 2: // Overdenture bridge
                setBridge(material,"overDenture");
                setOverDentureType(null);
                break;
        }

        //DONE
        setActiveTeeth([]);
        setAppState("choose-teeth");
    }

    const typeChanged = (newType)=>{
        setType(newType)
    }

    const getMaterialState = ()=>{
        if(type === null) return  "no-type";
        else if(appState === "choose-teeth") return "no-teeth";
        else if(appState === "choose-material") return "show-materials" ;
    }

    const teethStateChange = (tooth,state)=>{

        setTeethState(prevState => {
            const newState = [...prevState];
            if(tooth === "all"){
                if(confirm(abraStr.healthyAllWarning)){
                    newState.forEach(item=>{
                        item.state = state;
                        if(state === "healthy") item.material = null;
                        return item;
                    })
                    setBridges([]);
                    setBridgeProgress(null);
                    setIsBridgeEditing(false);
                }

            }else {
                const curTooth =  newState.find(item => item.id === tooth);
                curTooth.state = state;
                curTooth.inBridge = (type !== 0);
                if(state === "healthy") {
                    curTooth.material = null;
                    curTooth.isTelescopicCrown = false;
                }
                if(type === 0 && state !== "healthy"){
                    curTooth.isTelescopicCrown = true;
                }
                if(state === "no-tooth" && type === 0) setActiveTeeth([]);
            }
            return newState;
        });
    }

    const canChangeMaterial =
        !activeTeeth.length  &&
        ["init","other"].includes(bridgeState) &&
        !bridgeProgress &&
        !overDentureType


    return (

            <div className='wrapper'>
                <div className='left-wrap'>
                    <Header
                        ChaClear={canClear()}
                        clear={clear}
                    />

                    <div className='flex panels'>
                        <TypePanel
                            curType={type}
                            changeType={typeChanged}
                            setAppState={setAppState}
                            canChange={canChangeMaterial}
                            overDentureType={overDentureType}
                            setOverDentureType={setOverDentureType}
                            getPositionsWithoutBridges={()=> getPositionsWithoutBridges(bridges)}
                            setBridgeProgress={setBridgeProgress}
                            setBridgeState={setBridgeState}
                        />

                        <MaterialPanel
                            materialsState={getMaterialState()}
                            changeMaterial={materialChanged}
                            type={type}
                        />
                    </div>

                    <TeethChart
                        teeth={teethState}
                        setTeethState={teethStateChange}
                        setTeethStateRaw={setTeethState}
                        setAppState={setAppState}
                        setActiveTeeth={setActiveTeeth}
                        activeTeeth={activeTeeth}
                        curType={type}
                        bridgeState={bridgeState}
                        setBridgeState={setBridgeState}
                        bridges={bridges}
                        setBridges={setBridges}
                        bridgeProgress={bridgeProgress}
                        setBridgeProgress={setBridgeProgress}
                        isBridgeEditing={isBridgeEditing}
                        setIsBridgeEditing={setIsBridgeEditing}
                        setBridge={setBridge}
                        overDentureType={overDentureType}
                        popState={popState}
                        setPopState={setPopState}
                />
                </div>
                <div className='right-wrap'>

                    <AdditionalInfo
                        teeth={teethState}
                        setCurrency={setCurrency}
                        currency={currency}
                        fieldsState={fieldsState}
                        setFields={setFields}
                        bridges={bridges}
                        setCurScreen={setCurScreen}
                    />

                </div>
            </div>
    );
}

export default Planning;